import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "./img/CYBER ARCADIA LOGO-07 (1).png";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // ✅ Ensure only one dropdown opens at a time
  const toggleDropdown = (menu) => {
    setOpenDropdown((prev) => (prev === menu ? null : menu));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsOpen(false);
        setOpenDropdown(null); // ✅ Close dropdowns when clicking outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isNotHomePage = location.pathname !== "/";

  return (
    <div
      className="nav-bg container-fluid sticky-top"
      style={{
        background: isNotHomePage || isScrolled ? "rgb(0, 47, 88)" : "transparent",
        transition: "background 0.3s ease-in-out",
      }}
    >
      <div className="container">
        <nav className="navBg navbar navbar-expand-lg navbar-dark p-0" ref={navRef}>
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="Cyber Security Logo" className="navbar-logo" />
          </Link>

          {/* ✅ Mobile Menu Toggle */}
          <button
            type="button"
            className="navbar-toggler ms-auto me-0"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarCollapse">
            <div className="navbar-nav ms-auto">
              {/* ✅ Close mobile menu on navigation */}
              <Link to="/" className={`nav-item nav-link ${location.pathname === "/" ? "active-nav" : ""}`} onClick={() => setIsOpen(false)}>
                Home
              </Link>

              {/* ✅ About Dropdown */}
              <div className="nav-item dropdown">
                <button className={`nav-item nav-link btn ${openDropdown === "about" ? "active-nav" : ""}`} onClick={() => toggleDropdown("about")}>
                  About
                </button>
                <div className={`dropdown-menu bg-light ${openDropdown === "about" ? "show" : ""}`}>
                  <Link to="/about" className="dropdown-item" onClick={() => setIsOpen(false)}>About Us</Link>
                  <Link to="/whychooseus" className="dropdown-item" onClick={() => setIsOpen(false)}>Why Choose Us?</Link>
                  <Link to="/portfoliocompany" className="dropdown-item" onClick={() => setIsOpen(false)}>Portfolio Companies</Link>
                </div>
              </div>

              <Link to="/services" className={`nav-item nav-link ${location.pathname === "/services" ? "active-nav" : ""}`} onClick={() => setIsOpen(false)}>
                Services
              </Link>

              {/* ✅ Insights Dropdown */}
              <div className="nav-item dropdown">
                <button className={`nav-item nav-link btn ${openDropdown === "insights" ? "active-nav" : ""}`} onClick={() => toggleDropdown("insights")}>
                  Insights
                </button>
                <div className={`dropdown-menu bg-light ${openDropdown === "insights" ? "show" : ""}`}>
                  {/* <Link to="/latestfeatures" className="dropdown-item" onClick={() => setIsOpen(false)}>The Latest in Cybersecurity</Link>
                  <Link to="/critical" className="dropdown-item" onClick={() => setIsOpen(false)}>Why Cybersecurity is Critical</Link> */}
                  <Link to="/ISOAIM" className="dropdown-item" onClick={() => setIsOpen(false)}>Ensuring Trustworthy AI</Link>
                </div>
              </div>

              <Link to="/career" className={`nav-item nav-link ${location.pathname === "/career" ? "active-nav" : ""}`} onClick={() => setIsOpen(false)}>
                Career
              </Link>

              <Link to="/ourteam" className={`nav-item nav-link ${location.pathname === "/ourteam" ? "active-nav" : ""}`} onClick={() => setIsOpen(false)}>
                Our Team
              </Link>

              <Link to="/contact" className={`nav-item nav-link ${location.pathname === "/contact" ? "active-nav" : ""}`} onClick={() => setIsOpen(false)}>
                Contact
              </Link>

              
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
